/**
 * Allowlist de prefixos de rota conhecidos do catálogo do app.
 * SECURITY: nunca navegar para rota não listada aqui, independente do que o backend envie.
 *
 * Extraído de `ai-assistant-overlay.component.ts` (D71): o overlay está no teto de 521 linhas
 * e não pode crescer — esta constante não muda de comportamento, só de arquivo.
 */
export const ROTAS_CONHECIDAS: ReadonlySet<string> = new Set<string>([
  '/home',
  '/cadastro/pessoas',
  '/cadastro/clientes',
  '/cadastro/fornecedores',
  '/cadastro/transportadoras',
  '/venda',
  '/pdv',
  '/servicos/servicos',
  '/servicos/os',
  '/estoque',
  '/financeiro',
  '/fiscal',
  '/config',
  '/relatorio',
]);
